import { Link } from "react-router-dom";
import { CardMedia } from "@mui/material";
import { Box } from "@mui/material";
import Typography from "../typography/typography";
import "./module-button.scss"; // Import the external CSS file

export interface IModuleTile {
  module: {
    bg: string;
    icon: string;
    label: string;
    link: string;
  };
}

export const ModuleTile = (props: IModuleTile) => {
  const bgClass = props.module.bg === "transparent" ? "transparent" : "";

  return (
    <Link to={props.module.link}>
      <Box className="module-tile-container">
        <Box
          className={`module-box ${bgClass}`}
          style={{ background: props.module.bg }}
        >
          <CardMedia
            component="img"
            image={props.module.icon}
            alt={`${props.module.label} logo`}
          />
        </Box>
        <Typography type="s3" className="module-label">
          {props.module.label}
        </Typography>
      </Box>
    </Link>
  );
}

export default ModuleTile;